import React from "react";
import { MessageCircle } from "lucide-react";
import { CONTACT_INFO } from "@/i18n/translations";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float"
      href={`https://wa.me/${CONTACT_INFO.whatsappRaw}?text=${encodeURIComponent("Olá Decrepalma, gostaria de mais informações.")}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Decrepalma"
      className="fixed bottom-6 left-6 z-40 flex items-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white px-4 py-3 shadow-lg shadow-black/20 transition-all duration-300 hover:-translate-y-0.5 group"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2} />
      <span className="text-xs uppercase tracking-[0.2em] hidden sm:inline-block">
        WhatsApp
      </span>
    </a>
  );
}
